// @ts-check
import React from 'react';
import { Drawer, DrawerHeader } from 'preferral-ui/components/Drawer';
import { CopyButton } from 'preferral-ui/components/CopyButton';

/** @typedef {{
  isOpen: boolean;
  onClose(): void;
  rule: any;
}} ExportRuleJSONDrawerProps */

/** @type { React.FC<ExportRuleJSONDrawerProps> } */
export const ExportRuleJSONDrawer = (props) => {
  const { isOpen, onClose, rule } = props;

  return (
    <Drawer isOpen={isOpen} onRequestClose={onClose} width="md">
      <DrawerHeader icon="copy" title="Export Rule" onClose={onClose} />

      <div className="p-4">
        <div className="flex flex-col space-y-2">
          <div className="text-center">
            <CopyButton text={JSON.stringify(rule, null, 2)} size="sm">
              Click to Copy
            </CopyButton>
          </div>
          <pre className="shodow-inner flex-grow p-1 font-mono text-xs text-green-300 bg-gray-800 rounded-lg">
            {JSON.stringify(rule, null, 2)}
          </pre>
        </div>
      </div>
    </Drawer>
  );
};
